import { useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'

/**
 * Custom hook for fetching games data
 * @param {Object} params - Hook parameters
 * @param {Function} params.setGames - Function to set games state
 * @param {Function} params.setIsLoading - Function to set loading state
 * @returns {Object} Hook utilities and functions
 */
export const useGetGames = ({ setGames, setIsLoading }) => {
  /**
   * Fetch games data and transform it for select options
   */
  const getGames = useCallback(() => {
    setIsLoading(true)
    API.request({
      ...API_ROUTER.games.getGames,
    })
      .then(res => {
        let newOptions = []
        res?.games?.map(el => {
          newOptions = [...newOptions, { id: el.id, value: el.title }]
        })
        setGames(newOptions)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }, [setGames, setIsLoading])

  return {
    getGames,
  }
}

export default useGetGames
